import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/$slug/expenses")({
  component: Expenses,
});

function Expenses() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-primary-darker">Expenses</h1>
      <p className="mt-2 text-gray-500">Track and manage expenses.</p>
    </div>
  );
}
